import { sortTypes } from '../../../../helpers/sortFns';

export const filterKeys = {
  direction: 'direction',
};

export const columnKeys = {
  createTime: 'createTime',
  serviceCompany: 'serviceCompany',
  callerId: 'callerId',
  waitingTime: 'waitingTime',
  clearWaitingTime: 'clearWaitingTime',
  talkTime: 'talkTime',
  requests: 'requests',
  operator: 'operator.shortName',
  operatorServiceCompany: 'operator.serviceCompany.name',
  recording: 'recording',
};

export const callListColumns = [
  {
    key: columnKeys.createTime,
    width: `8%`,
    title: 'Время звонка',
    sortType: sortTypes.date,
  },
  {
    key: columnKeys.serviceCompany,
    width: `13%`,
    title: 'УК',
    sortType: sortTypes.string,
  },
  {
    key: columnKeys.callerId,
    width: `13%`,
    title: 'Номер',
    filterKey: filterKeys.direction,
    filterMultiple: false,
  },
  {
    key: columnKeys.waitingTime,
    width: `9%`,
    title: 'Время ожидания',
    sortType: sortTypes.number,
  },
  {
    key: columnKeys.clearWaitingTime,
    width: `9%`,
    title: 'Чистое время ожидания',
    sortType: sortTypes.number,
  },
  {
    key: columnKeys.talkTime,
    width: `9%`,
    title: 'Время разговора',
    sortType: sortTypes.number,
  },
  {
    key: columnKeys.requests,
    width: `13%`,
    title: '№ заявки',
  },
  {
    key: columnKeys.operator,
    width: `10%`,
    title: 'Оператор',
    sortType: sortTypes.string,
  },
  {
    key: columnKeys.operatorServiceCompany,
    width: `11%`,
    title: 'УК оператора',
    sortType: sortTypes.string,
  },
  {
    key: columnKeys.recording,
    width: `8%`,
    title: 'Запись',
  },
];

export const recordActionTypes = {
  download: 'download',
  play: 'play',
};
